module.exports = __webpack_public_path__ + "static/media/entrega_icon.6d29b806.webp";